import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { ArrowUpRight } from "@phosphor-icons/react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#070b14] text-[#f5ecd9]" data-testid="site-footer">
      <div className="rainbow-bar rainbow-bar-xl" />

      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 pt-24 pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-6 space-y-6">
            <Logo />
            <p className="text-lg text-[#a8b2cc] leading-relaxed max-w-md">
              Connecting South African businesses to the networks that matter —
              MTN, Vodacom, Cell C, Vox and Telkom.
            </p>
            <div className="flex gap-3">
              <Link to="/contact" className="btn-primary" data-testid="footer-cta-button">
                Start a Conversation <ArrowUpRight size={14} weight="bold" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow mb-5">Navigate</div>
            <ul className="space-y-3">
      {[
                { to: "/", label: "Home" },
                { to: "/offers", label: "Offers" },
                { to: "/build-package", label: "Build Package" },
                { to: "/services", label: "Services" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-nav text-[#f5ecd9] hover:text-[#af3fa6] text-lg transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow mb-5">Get in Touch</div>
            <ul className="space-y-3 text-lg">
              <li>
                <a href="tel:0718889055" className="hover:text-[#af3fa6]" data-testid="footer-phone">
                  071 888 9055
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@infinity-dms.co.za"
                  className="hover:text-[#af3fa6] break-all"
                  data-testid="footer-email"
                >
                  info@infinity-dms.co.za
                </a>
              </li>
              <li className="text-[#a8b2cc]">10 Hampden Road, Morningside</li>
              <li className="text-[#a8b2cc]">South Africa — nationwide</li>
            </ul>
            <div className="mt-8 flex flex-wrap gap-2">
              <span className="brand-chip border border-[#2c3854] text-[#a8b2cc]">
                MTN
              </span>
              <span className="brand-chip border border-[#2c3854] text-[#a8b2cc]">
                Vodacom
              </span>
              <span className="brand-chip border border-[#2c3854] text-[#a8b2cc]">
                Cell C
              </span>
              <span className="brand-chip border border-[#2c3854] text-[#a8b2cc]">
                Vox
              </span>
              <span className="brand-chip border border-[#2c3854] text-[#a8b2cc]">
                Telkom
              </span>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#2c3854] flex flex-col md:flex-row justify-between gap-3 text-sm text-[#a8b2cc]">
          <div>© {year} Infinity Data &amp; Mobile Solutions</div>
          <div className="font-mono-accent text-[0.72rem] uppercase tracking-[0.22em]">
            Built for bandwidth · Engineered for clarity
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
